export default {
      id: "email-usage",
      viewBox: "0 0 30 24",
      url: "../../assets/" + "sprite.svg#email-usage",
      toString: function () {
        return this.url;
      }
    }